// import { DateFunctions as DateFunctions } from './date_functions';
// import store from '../../store';

class ClsUser {
  static f_checkUserAuth = function(check_auth_list, auth_id_mode='') {
    this.d_user = JSON.parse(localStorage.getItem('user'));
    let auth_eligible = false;
    if (this.d_user && ((this.d_user.auth && this.d_user.auth.length > 0) || (this.d_user.auth_with_id && this.d_user.auth_with_id.length > 0))) {
      for (let check_auth_list_index in check_auth_list) {
        // uuid_shop_admin: yetkinin '_' ile bölünmesi durumunda uuid tarafında '_' olmayacağı için '_'den split ettikten sonraki 1 ve sonraki indexler yetki kodumuza direkt eşit olmaktadır.
        if (this.d_user.auth.indexOf(check_auth_list[check_auth_list_index]) !== -1) {
          auth_eligible = true;
          break;
        } else {
          if (auth_id_mode === 'without_id') {
            for (let auth_index in this.d_user.auth_with_id) {
              let auth_code = this.d_user.auth_with_id[auth_index].split('_').slice(1).join('_');
              if (check_auth_list[check_auth_list_index] === auth_code) {
                auth_eligible = true;
                break;
              }
            }
          } else if (auth_id_mode === 'with_id') {
            if (this.d_user.auth_with_id.indexOf(check_auth_list[check_auth_list_index]) !== -1) {
              auth_eligible = true;
              break;
            }
          }
        }
      }
    }
    return auth_eligible;
  };
}
export { ClsUser };
